// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itareqspg-inline-1 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.itareqspg-inline-2 {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.itareqspg-inline-3 {
  padding: 0;
  overflow-x: auto;
}

.itareqspg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.itareqspg-inline-5 {
  font-weight: 600;
}

.itareqspg-inline-6 {
  font-size: 11px;
}

.itareqspg-inline-7 {
  max-width: 240px;
  font-size: 11px;
  color: #475569;
}

.itareqspg-inline-8 {
  margin-bottom: 12px;
}

.itareqspg-inline-9 {
  font-size: 12px;
  background: #f8fafc;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.itareqspg-inline-10 {
  font-size: 12px;
  background: #eff6ff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.itareqspg-dyn-1 {
  margin-left: auto;
  font-size: 12px;
  color: var(--itareqspg-1-color);
}

.itareqspg-dyn-2 {
  text-align: center;
  padding: 30px;
  color: var(--itareqspg-2-color);
}

.itareqspg-dyn-3 {
  text-align: center;
  padding: 30px;
  color: var(--itareqspg-3-color);
}

.itareqspg-dyn-4 {
  font-size: 11px;
  font-weight: 600;
  color: var(--itareqspg-4-color);
}

.itareqspg-dyn-5 {
  font-size: 11px;
  color: var(--itareqspg-5-color);
}

.itareqspg-dyn-6 {
  font-size: 11px;
  color: var(--itareqspg-6-color);
  margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITAReqsPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB","sourcesContent":[".itareqspg-inline-1 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.itareqspg-inline-2 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.itareqspg-inline-3 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.itareqspg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itareqspg-inline-5 {\n  font-weight: 600;\n}\n\n.itareqspg-inline-6 {\n  font-size: 11px;\n}\n\n.itareqspg-inline-7 {\n  max-width: 240px;\n  font-size: 11px;\n  color: #475569;\n}\n\n.itareqspg-inline-8 {\n  margin-bottom: 12px;\n}\n\n.itareqspg-inline-9 {\n  font-size: 12px;\n  background: #f8fafc;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.itareqspg-inline-10 {\n  font-size: 12px;\n  background: #eff6ff;\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.itareqspg-dyn-1 {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--itareqspg-1-color);\n}\n\n.itareqspg-dyn-2 {\n  text-align: center;\n  padding: 30px;\n  color: var(--itareqspg-2-color);\n}\n\n.itareqspg-dyn-3 {\n  text-align: center;\n  padding: 30px;\n  color: var(--itareqspg-3-color);\n}\n\n.itareqspg-dyn-4 {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--itareqspg-4-color);\n}\n\n.itareqspg-dyn-5 {\n  font-size: 11px;\n  color: var(--itareqspg-5-color);\n}\n\n.itareqspg-dyn-6 {\n  font-size: 11px;\n  color: var(--itareqspg-6-color);\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
